import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import Area from 'src/app/models/Area';
import { Cacheable } from 'ts-cacheable';
import { BaseService } from '../base.service';

@Injectable({
  providedIn: 'root',
})
export class AreaService extends BaseService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  @Cacheable({
    maxAge: 1000 * 60 * 60,
  })
  fetchAll(): Observable<Area[]> {
    return this.callGet('/areas').pipe(
      map((response: any) => {
        if (response && Array.isArray(response.data)) {
          return response.data.map(Area.parseFromData);
        }
        return [];
      }),
      catchError((response: HttpErrorResponse) =>
        this.getResponseMessage(response, 'Unable to fetch areas')
      )
    );
  }
}
